import React from "react";

const Compare = ({color}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M15.0333 23.3346V22.0013H11C10.7333 22.0013 10.5 21.9013 10.3 21.7013C10.1 21.5013 10 21.268 10 21.0013V11.0013C10 10.7346 10.1 10.5013 10.3 10.3013C10.5 10.1013 10.7333 10.0013 11 10.0013H15.0333V8.66797H16.0333V23.3346H15.0333ZM11 20.3013H15.0333V15.6846L11 20.3013ZM17.0333 22.0013V15.7513L21 20.3013V11.0013H17.0333V10.0013H21C21.2667 10.0013 21.5 10.1013 21.7 10.3013C21.9 10.5013 22 10.7346 22 11.0013V21.0013C22 21.268 21.9 21.5013 21.7 21.7013C21.5 21.9013 21.2667 22.0013 21 22.0013H17.0333Z"
        fill={color}
      />
      <rect x="0.5" y="0.5" width="31" height="31" rx="4.5" stroke={color} />
    </svg>
  );
};

export default Compare;
